import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// native components
import LeadersTwoColumnContent from '../leadersTwoColumnContent';
// images
import profilePicWebp from './images/ceo-tim-gerend.webp';
// styles
import {
  LinkedinStyledSocialIcon,
  LinkStyledBio,
} from '../../styles';

export default () => {
  const name = 'Timothy J. Gerend';
  const nameString = 'tim-gerend';
  const title = 'Chairman, President, and Chief Executive Officer';

  return (
    <LeadersTwoColumnContent
      id='leaders-chief-executive-officer'
      header={name}
      title={title}
      content={(
        <>
          <Typography
            itemprop='description'
            nextElement='link'>
            Tim joined Northwestern Mutual as an attorney, and later held a number of leadership roles across the enterprise&#8212;including law, compliance, field compensation, and campus planning. Most recently as executive vice president and chief distribution officer, he was responsible for the company&#39;s go&#45;to&#45;market strategy, including the company&#39;s exclusive field force of more than 20,000 advisors and team members, and our strategic communications and marketing strategies.
          </Typography>
          <LinkStyledBio
            id={`leaders-section-${nameString}-bio-pdf-link`}
            linkUrl='/assets/pdf/leaders/gerend-tim-bio.pdf'
            ariaLabel={`Download the bio pdf for ${name}`}
            isInternalPdf
            endAdornment={CaratRight}
            endAdornmentStylesReset
            variant='buttonLinkTertiary'>
            See full bio
          </LinkStyledBio>
          <Row>
            <Col nested>
              <Link
                id={`leaders-section-${nameString}-linkedin-social-link`}
                variant='primary'
                linkUrl='https://www.linkedin.com/in/tim-gerend-67753425/'
                ariaLabel={`${name} Linkedin profile`}
                isOutgoingLink>
                <LinkedinStyledSocialIcon />
              </Link>
            </Col>
          </Row>
        </>
      )}
      image={profilePicWebp}
      imageAlt={`Northwestern Mutual ${title} ${name}.`}
      reversed={false}
    />
  );
};
